import { APP_SIGN_UP_URL } from "@/lib/appLinks";
import { Check, ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const INCLUDED = [
  "Your public Guinep Seed page",
  "Services, prices, Now updates and policies",
  "Structured enquiries into WhatsApp",
  "Share Kit",
  "Simple activity insights",
];

const Pricing = () => (
  <section id="pricing" className="scroll-mt-20 bg-guinep-soft py-20 sm:py-24">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Chapter num="04" label="Simple pricing" />
      <div className="mt-10 max-w-2xl">
        <Reveal delay={0.05}>
          <h2 className="font-serif text-3xl font-medium leading-[1.12] tracking-tight text-guinep-ink sm:text-5xl">
            Simple pricing.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-5 text-base leading-relaxed text-guinep-mute sm:text-lg">
            One simple plan for solo and very small service businesses.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="mt-14">
        <div
          data-testid="pricing-founding-card"
          className="mx-auto grid max-w-4xl overflow-hidden rounded-3xl border border-guinep-line bg-white shadow-[0_32px_72px_-32px_rgba(31,58,43,0.35)] md:grid-cols-[0.9fr_1.1fr]"
        >
          <div className="flex flex-col justify-between bg-guinep-deep p-9 text-white sm:p-11">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-guinep-soft/80">
                One simple plan
              </p>
              <div className="mt-6">
                <span className="font-serif text-5xl font-medium leading-none sm:text-6xl">14 days free</span>
              </div>
              <div className="mt-4 space-y-1.5">
                <p className="text-sm text-white/90">Then <span className="font-semibold text-white">$9</span> for your first month</p>
                <p className="text-sm text-white/90"><span className="font-semibold text-white">$12/month</span> after that</p>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-white/65">
                No commission. No transaction fees. Cancel anytime.
              </p>
            </div>
            <a
              href={APP_SIGN_UP_URL}
              data-testid="pricing-cta-button"
              className="group mt-9 inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-base font-semibold text-guinep-deep transition-colors duration-300 hover:bg-guinep-soft"
            >
              Get started
              <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>

          <div className="p-9 sm:p-11">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-guinep-mute">
              Everything included
            </p>
            <ul className="mt-6 grid gap-x-6 gap-y-3.5 sm:grid-cols-2">
              {INCLUDED.map((item) => (
                <li key={item} className="flex items-start gap-3" data-testid="pricing-included-item">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-guinep-soft text-guinep-mid">
                    <Check size={11} strokeWidth={3} />
                  </span>
                  <span className="text-sm leading-relaxed text-guinep-ink">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
